import { ForwardedRef, forwardRef, useState } from "react";
import AsyncCreatableSelect from "react-select/async-creatable";
import { IdValue } from "components/Shared/Select/useIdValue";
import CreateRetailerModal from "components/Shared/RetailerDirectory/CreateModal";
import {
  Option,
  RetailerSelectInstance,
  RetailerSelectProps,
  useRetailerSelect,
} from "./RetailerSelect";

function CreatableRetailerSelectInner<IsMulti extends boolean = false>(
  props: RetailerSelectProps<IsMulti>,
  ref: ForwardedRef<RetailerSelectInstance<IsMulti>>,
) {
  const { isAdmin, isMulti, value, onChange } = props;
  const selectProps = useRetailerSelect<IsMulti>(props);

  const [createRetailerName, setCreateRetailerName] = useState<string | null>(
    null,
  );

  return (
    <>
      <AsyncCreatableSelect<Option, IsMulti>
        ref={ref}
        {...selectProps}
        formatCreateLabel={(inputValue) => `Create retailer: “${inputValue}”`}
        isValidNewOption={(inputValue) => inputValue.length > 1}
        onCreateOption={(inputValue) => setCreateRetailerName(inputValue)}
      />

      <CreateRetailerModal
        defaultValues={{ name: createRetailerName }}
        isAdmin={isAdmin}
        isOpen={!!createRetailerName}
        onClose={() => setCreateRetailerName(null)}
        onCompleted={(id) => {
          setCreateRetailerName(null);
          onChange?.(
            (isMulti ? [...(value as string[]), id] : id) as IdValue<
              IsMulti,
              string
            >,
          );
        }}
      />
    </>
  );
}

export default forwardRef(CreatableRetailerSelectInner);
